import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createSlots as _createSlots, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "px-6 py-3"
}
const _hoisted_2 = { class: "space-y-6" }
const _hoisted_3 = {
  key: 1,
  class: ""
}
const _hoisted_4 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_5 = { class: "px-6 py-3 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { key: 2 }

import AdminLayout from '@/layouts/AdminLayout.vue';
import FilterComponent from '@/components/FilterComponent.vue';
import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';
import TabComponent from '@/components/TabComponent.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import PagePagination from '@/components/PagePagination.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import LoadingModal from '@/components/modal/LoadingModal.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import ActivityLogsTable from '@/components/ActivityLogsTable.vue';

import throttle from "lodash/throttle";
import branch from "@/classes/Branch";
import { paginatePage } from '@/helpers/PageHelper';
import { useRouter } from 'vue-router';
import { onMounted, ref, computed, watch } from 'vue';
import { useNetworkStore } from '@/store/network';

/**
 * ********************************
 * Data 
 * ********************************
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router          = useRouter();
const loader          = ref(false);
const showError       = ref(false);
const errorMsg        = ref();
const seletected      = ref();
const showConfirmation = ref(false);
const showSuccess     = ref(false);

const currentRoutePath = computed(() => router.currentRoute.value.path);
const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

/**
 * ********************************
 * query 
 * ********************************
 */
const searchText = ref();
const activeTab  = ref();
const goToPage   = ref();
const tab   = ref('all');

/**
 * ********************************
 * Page Renderer Data 
 * ********************************
 */
const items           = ref(null);
const items_count     = ref(null);
const rows            = ref(null);
const query           = ref(null);
const selected_tab    = ref('all');
const filterDate       = ref(null);
const log_event       = ref(null);
const log_query       = ref(null);
const log_date        = ref(null);
const active_count    = ref(0);
const archived_count  = ref(0);
const log_counts      = ref(0);
const logs            = ref({});
const log_event_lists = ref(null);

// Tabs

const tabs: { name: string, count: number, href: string, allowed: boolean }[] = computed(() => [
    {
        name: 'Active',
        count: active_count.value,
        href: '/branches',
        allowed: true
    },
    {
        name: 'Archived',
        count: archived_count.value,
        href: "/branches/archived",
        allowed: isNetworkAvailable.value
    },
    {
        name: 'Activity logs',
        count: log_counts.value,
        href: "/branches/logs",
        allowed:
            isNetworkAvailable.value &&
            window.$hasPermission('view-activity-logs')
    }
]);

// Headers
const headers: { text: string }[] = [
    { text: 'Branch' },
    { text: 'Date Created'}
];


const hasPermission = ():boolean => {
    return window.$hasPermission('view-individual-patient') ||
            window.$hasPermission('view-corporate-patient') ||
            window.$hasPermission('view-individual-patient-schedule') ||
            window.$hasPermission('view-bookings-in-offline') ||
            window.$hasPermission('soft-book-dates-for-individual-patient')
}
/**
 * ********************************
 * Methods 
 * ********************************
 */
const applyFilters = () => {
    indexBranch(goToPage.value)
}

const searchData = (val: string) => {
    searchText.value = val
}

const indexBranch = async (data: string) => {
    // console.log(isNetworkAvailable.value);
    if(isNetworkAvailable.value && hasPermission()) {
        console.log("Online - Fetching Branches...")
        try {
            loader.value = true;
            const queryString     = searchText.value ? `&query=${searchText.value}` : 'query';
            const dateQuery       = filterDate.value ? `&filterDate=${filterDate.value}` : '';
            const isArchivedRoute = currentRoutePath.value === '/branches/archived';
            const tabValue        = isArchivedRoute ? 'archived' : tab.value;
            const goToPageValue   = paginatePage(data);
            
            const response = await branch.indexBranch(`${goToPageValue}&tab=${tabValue}&${queryString}&${dateQuery}`)
            
            items.value           = response?.data.items;
            items_count.value     = response?.data.items_count
            rows.value            = response?.data.rows
            query.value           = response?.data.query
            selected_tab.value    = response?.data.selected_tab
            log_event.value       = response?.data.log_event
            log_query.value       = response?.data.log_query
            log_date.value        = response?.data.log_date
            active_count.value    = response?.data.active_count
            archived_count.value  = response?.data.archived_count
            log_counts.value      = response?.data.log_counts
            logs.value            = response?.data.logs
            log_event_lists.value = response?.data.log_event_lists
        }
        catch(error) {
            showError.value = true;
            errorMsg.value = error.response.data.message;
                
            if(error?.response?.status == 401) {
                window.location.replace('/login');
            }
        }
        finally {
            loader.value = false;
        }
    } else {
        console.log("Offline - Fetching Branches...")
        try {
            loader.value = true;
            
            const response = await branch.indexBranch(`row=999`)
            
            items.value           = response?.data.items;
        }
        catch(error) {
            showError.value = true;
            errorMsg.value = "Oppps... No available data was saved for offline use.";
        }
        finally {
            loader.value = false;
        }
    }
    
}
/**
 * ********************************
 * Archive Branch 
 * ********************************
 */
 const selectedBranch = (id: string) => {
    showConfirmation.value = true
    seletected.value = id
}

const archiveBranch = async () => {
    try {
        loader.value = true;
        await branch.deleteBranch(seletected.value);
        loader.value = false;
        window.location.replace('/branches/archived');
    } catch (err) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = err?.response?.data.message;
    }
};

/**
 * ********************************
 * Restore Branch 
 * ********************************
 */

 const restoreBranch = async (id: string) => {
    try {
        loader.value = true;
        await branch.restoreBranch(id);
        loader.value = false;
        window.location.replace('/branches')
    } catch (err) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = err?.response?.data.message;
    }
};

const preCacheLoader = ref(false);

const preCacheBranches = async () => {

    const cache = await caches.open('shinagawa-admin');
    const cachedResponse = await cache.match(`${process.env.VUE_APP_API_URL}branches/index?row=999`);

    if(!cachedResponse) {
        preCacheLoader.value = true;
        try {
            // Precache Branches
            await branch.indexBranch(`row=999`)
            // const total = response.data.total;
            // const pages = Math.ceil(total / 10);
    
            // for (let index = 0; index < pages; index++) {
            //     const page = index + 1;
            //     const res = await branchBooking.indexBranch(`page=${page}`)
            // }
    
        } catch(error: any){
            console.log(error.response.status)
        }
        preCacheLoader.value = false;
    }
}

/**
 * ********************************
 * Export Branch 
 * ********************************
 */
 const exportData = async () => {
    try {
        loader.value = true;
        const params = currentRoutePath.value === '/branches/archived' ? 'tab=archived' : '';

        await branch.exportBranch(params);
        showSuccess.value = true;
    } catch (error) {
        showError.value = true;
        errorMsg.value  = error.response?.data.message;
    } finally {
        loader.value = false;
    }
};

const downloadResources = async () => {
    caches.delete('shinagawa-admin');
    
    // setTimeout(() => {
        preCacheBranches();
    // }, 1000);
}

watch(
    searchText,
    throttle(() => {
        indexBranch(goToPage.value)
    }, 1000)
);

watch(
    () => isNetworkAvailable.value,
    (val) => {
        console.log('Watcher - Network: ' + val);
        indexBranch(goToPage.value);
    }
);

onMounted(() => {
    loader.value = true;
    setTimeout(() => {
        console.log('Mounted Hook - Network: ' + isNetworkAvailable.value);
        indexBranch(goToPage.value);
        // preCacheBranches(); // Uncomment to pre-cache branches on mount
    }, 1000);
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, { title: "Branches" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, {
          tabs: tabs.value,
          "button-items": true
        }, _createSlots({ _: 2 }, [
          (isNetworkAvailable.value)
            ? {
                name: "buttons",
                fn: _withCtx(() => [
                  _createVNode(ButtonComponent, {
                    class: "text-gray-900",
                    secondary: "",
                    exportBtn: "",
                    onClick: exportData,
                    disabled: loader.value
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode(" Export ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"]),
                  (_ctx.$hasPermission('create-branch') && _ctx.$hasPermission('set-clinic-hours'))
                    ? (_openBlock(), _createBlock(ButtonComponent, {
                        key: 0,
                        createBtn: "",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/branches/create')))
                      }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode(" Create ", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["tabs"])
      ]),
      (isNetworkAvailable.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(FilterComponent, {
              search: searchText.value,
              "text-filters": currentRoutePath.value !== '/branches/logs',
              onFetchData: searchData,
              "onUpdate:filters": applyFilters,
              "custom-filters": activeTab.value !== 'activity_logs'
            }, {
              fields: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(DatePicker, {
                    id: "filterDate",
                    name: "filterDate",
                    range: "",
                    is24: "",
                    isPresetRanges: "",
                    modelValue: filterDate.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterDate).value = $event)),
                    placeholder: "Start Date & End Date",
                    label: "Start Date & End Date"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            }, 8, ["search", "text-filters", "custom-filters"])
          ]))
        : _createCommentVNode("", true),
      (currentRoutePath.value !== '/branches/logs')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(DataTable, {
              headers: headers,
              count: items.value?.data.length
            }, {
              body: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value?.data, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_4, _toDisplayString(item.name), 1),
                    _createElementVNode("td", _hoisted_5, _toDisplayString(item.formatted_created_at), 1),
                    _createElementVNode("td", _hoisted_6, [
                      (
                                    _ctx.$hasPermission('view-branch') || 
                                    _ctx.$hasPermission('update-branch') || 
                                    _ctx.$hasPermission('update-clinic-hours') ||
                                    _ctx.$hasPermission('create-blocked-date') ||
                                    _ctx.$hasPermission('update-blocked-date') ||
                                    _ctx.$hasPermission('archive-blocked-date') ||
                                    _ctx.$hasPermission('restore-blocked-date') || 
                                    _ctx.$hasPermission('create-company') ||
                                    _ctx.$hasPermission('update-company') ||
                                    _ctx.$hasPermission('archive-company') ||
                                    _ctx.$hasPermission('restore-company') ||
                                    _ctx.$hasPermission('view-company') || 
                                    _ctx.$hasPermission('soft-book-dates-for-individual-patient'))
                        ? (_openBlock(), _createBlock(ActionButton, {
                            key: 0,
                            "edit-btn": "",
                            onClick: ($event: any) => (_unref(router).push(isNetworkAvailable.value ? `/branches/edit/${item.id}` : `/branches/${item.id}/bookings`))
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (isNetworkAvailable.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (!item.deleted_at && _ctx.$hasPermission('archive-branch'))
                              ? (_openBlock(), _createBlock(ActionButton, {
                                  key: 0,
                                  "delete-btn": "",
                                  onClick: ($event: any) => (selectedBranch(item.id))
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (item.deleted_at && _ctx.$hasPermission('restore-branch'))
                              ? (_openBlock(), _createBlock(ActionButton, {
                                  key: 1,
                                  "restore-btn": "",
                                  onClick: ($event: any) => (restoreBranch(item.id))
                                }, null, 8, ["onClick"]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["count"]),
            _createVNode(PagePagination, {
              class: "mb-6",
              items: items.value,
              onNextPage: indexBranch
            }, null, 8, ["items"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(ActivityLogsTable, {
              logs: logs.value,
              onFetchIndex: indexBranch
            }, null, 8, ["logs"])
          ])),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 3 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showError.value = false))
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(ConfirmationModal, {
        show: showConfirmation.value,
        onCancel: _cache[4] || (_cache[4] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[5] || (_cache[5] = ($event: any) => {showConfirmation.value = false; archiveBranch() }),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Archive Branch ?",
        content: "Are you sure you wish to archive this Branch ?"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[6] || (_cache[6] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[7] || (_cache[7] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Close",
        title: "Branch Export",
        content: "Export is being processed. Please check your registered email."
      }, null, 8, ["show"]),
      _createVNode(LoadingModal, {
        show: preCacheLoader.value && isNetworkAvailable.value,
        onCancel: _cache[8] || (_cache[8] = ($event: any) => (preCacheLoader.value = false)),
        onConfirm: _cache[9] || (_cache[9] = ($event: any) => (preCacheLoader.value = false)),
        restartLoader: preCacheLoader.value,
        title: "Downloading Resources",
        content: "Resources is being download for offline use. Please wait."
      }, null, 8, ["show", "restartLoader"])
    ]),
    _: 1
  }))
}
}

})